// extracted by mini-css-extract-plugin
export default {"htmlTemplateContainer":"htmlTemplateContainer___Z9XmK","contractHeader":"contractHeader___iFzsp","contractHeaderLinks":"contractHeader-links___ZIXHs","contractHeaderLeft":"contractHeader-left___hWaDs","contractHeaderRight":"contractHeader-right___L_NFy","contractAcceptance":"contractAcceptance___vgWof","contractBody":"contractBody___NYrwD"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"htmlTemplateContainer\":\"htmlTemplateContainer___Z9XmK\",\"contractHeader\":\"contractHeader___iFzsp\",\"contractHeaderLinks\":\"contractHeader-links___ZIXHs\",\"contractHeaderLeft\":\"contractHeader-left___hWaDs\",\"contractHeaderRight\":\"contractHeader-right___L_NFy\",\"contractAcceptance\":\"contractAcceptance___vgWof\",\"contractBody\":\"contractBody___NYrwD\"}";
        // 1793029702955
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  